/*Recurso: Catalogs - Variables y rutinas store que almacenan la respuesta del API y su manipulación en el front
  Tareas:
    GetAllOrigin              //Origen del cambio        //*Propuesta
    GetAllProcessByFrequency  //Procesos por frecuencia  //*Propuesta  
    GetAllDecision            //Decisión                 //*RP *RD    
    GetAllQuality             //Principios               //*RP
    GetAllCycles              //Ciclos                   //*RP
*/
//elementos stores: elementos que llenamos con inf. del api y otros elementos captados del front o para manejo del front
//funciones stores: rutinas que captan o modifican los elementos store
//response: { config: {}, hearders:{}, request:{}, data: { informacion: {}, resultado: {}, contenido: [{ }] } } //esto trae la lectura de api

import create from "zustand";

const catalogsStore = create((set:any, get:any) => ({
 
  objErrorCatalogsStore: { hasError: false, url: '', body:'',  recurso:"catalogs", componente:'', idresul: 0, desresul:'', menu:''}, //se llena con la información del api si éste tiene error
   
    //*Limpia objeto de error cuando éste ya se mostro en VentanaObjeErrorAPI  
    limpiaObjErrorCatalogsStore: () => {
      let paso = { hasError: false, url:'', body:'', recurso:'catalogs', componente:'', idresul:0, desresul:'', menu:''}
      set( { objErrorCatalogsStore: paso } );
      //console.log('catalogsStore - limpiaObjErrorCatalogsStore (sale) - objErrorCatalogsStore: ', get().objErrorCatalogsStore);
    },
                
    //*Error en api // entra a esta función cuando el servicio cae en catch y muestra el error en VentanaObjError
    generaObjErrorCatalogsStore: async (responseAPI:any, h:any, h2:any, e:any, c:any, m:any) => {
      //console.log('*generaObjErrorCatalogsStore (entra): ', responseAPI);
      //console.log('*generaObjErrorCatalogsStore (entra): h: ', h , ' h2: ',  h2 , ' e: ', e , ' c: ', c );
      let paso = { hasError: h, url:'', body:e, recurso:'catalogs', componente:c, idresul:0, desresul:'', menu:m };
      if (responseAPI==undefined  || responseAPI=='Error: Network Error'){
          paso.idresul=-1;
          paso.desresul= 'Error inesperado, asegure su conexión con internet y vpn';
      }
      else if (responseAPI=='Error detectado por api en ret') {
        paso.desresul= h;
        paso.idresul= h2; 
      }
      else {
        let temp = responseAPI.config;
        paso.url = temp.url;
        if (responseAPI.data!='' && responseAPI.data!=null){
            paso.idresul=responseAPI.data.ret;
            paso.desresul= responseAPI.data.msjerror;
        }    
        else {
            paso.idresul= responseAPI.status;
            switch(responseAPI.status){
              //case 404:  paso.desresul= "El usuario no existe"; break;
              case 401:  paso.desresul= "No autorizado"; break;
              case 404:  paso.desresul= "No tiene información, error al leer la tarea del API"; break;
              default: paso.desresul= responseAPI.statusText; break;
            }
        }    
      }
      set( { objErrorCatalogsStore: paso } );
      console.log('::catalogsStore - generaObjErrorCatalogsStore (sale) - objErrorCatalogsStore: ', get().objErrorCatalogsStore);
    },

  catOrigenesStore: [], //response.data de la tarea:GetAllOriginStore +  elementos de uso en el front

    //*Tareas: GetAllOriginStore // *Propuesta //*RP  // catálogo de origen del cambio
    guardaGetAllOriginStore: async (responseAPI:any) => { 
      //console.log('guardaGetAllOriginStore - responseAPI:', responseAPI)
      set ( { catOrigenesStore: responseAPI } )

      get().catOrigenesStore.map((c:any) => {
          c.activo=false;
          c.disabled=false;
          c.specification='';
      });
      //console.log (':::catOrigenesStore: ', get().catOrigenesStore );
      return(get().catOrigenesStore);
    },

  catProcesosStore: [], //response.data de la tarea: GetAllProcessByFrequencyStore +  elementos de uso en el front
  
    //*Tareas: GetAllProcessByFrequency // *Propuesta //*RP   // catálogo de procesos por frecuencia
    guardaGetAllProcessByFrequencyStore: async (responseAPI:any) => {  
        //console.log('guardaGetAllProcessByFrequencyStore - responseAPI:', responseAPI)
        var _ = require('underscore');
        let catPaso:any = [];
        catPaso = responseAPI;
      
      //preparamos catProcesosStore con lo necesario para visualizar en front
        let i = 0;
        catPaso.map((p:any) => {
            p.processname = p.processname.trim().replace(/\s\s+/g, ' ');
            p.activo=false;
            p.disabled=false;
            p.title = "";

            if (p.assignedroles.length == 0) { p.ordena = 2} // el ordena es para agrupar primero los procesos donde el usuario tenga rol de RP o RD y pintarlos de azul en la lista
            else {
              for (i=0; i < p.t_userxrol.length; i++){
                  switch (p.t_userxrol[i] ) {
                    case 'RP':
                      p.ordena = 1;
                      p.title= "Proceso con rol de Responsable de Proceso";
                      p.clasexEstatus = "background-color-azul6  noBR";
                      break;
                    case 'RD':
                      p.ordena = 1;
                      p.title = "Proceso con rol de Responsable de Diseño";
                      p.clasexEstatus = "background-color-azul6  noBR";
                      break;
                    case 'US': 
                      p.ordena = 2;
                      p.title = "Proceso con rol de Usuario estratégico"; 
                      break;
                    case 'PC': 
                      p.ordena = 2;
                      p.title = "Proceso con rol de proponente"; break;
                    default:   
                      p.ordena = 2;
                      p.title = "Proceso con rol de proponente"; break;
                  }
              } 
              if (p.t_userxrol.length > 1) 
                  p.title ="Proceso con rol de Responsable de Proceso y Responsable de Diseño";
              else {
                  p.clasexEstatus = " noBR";
                  p.title ="Proceso sin rol específico";
              }
            }
            let paso = p.state_process;
            p.estatusProceso = paso.pt_state_description;
            p.clasexEstatusIcono = "";
            switch ( p.state_process.pt_state ) {
              case 1: p.clasexEstatusIcono = "claseEstatus claseEstatusAct"; break;
              case 2: p.clasexEstatusIcono = "claseEstatus claseEstatusEdi"; break;
              case 3: p.clasexEstatusIcono = "claseEstatus claseEstatusIna"; p.disabled=true; break;
              case 4: p.clasexEstatusIcono = "claseEstatus claseEstatusHis"; break;
              default: p.clasexEstatusIcono= "claseEstatus claseEstatusAct"; break;
            }
        })
        let catPaso2 =  _.sortBy(catPaso, 'ordena');
        set ( { catProcesosStore: catPaso2})
        //console.log (':::catProcesosStore: ', get().catProcesosStore );
        return(get().catProcesosStore);
    },

  catDecisionesStore: [], ///response.data de la tarea: GetAllDecision +  elementos de uso en el front

    //*Tareas: GetAllDecision  //*RP *RD
    guardaGetAllDecisionStore: async (responseAPI:any) => { 
      //console.log('guardaGetAllDecisionStore - responseAPI:', responseAPI)
      set ( { catDecisionesStore: responseAPI } )

      get().catDecisionesStore.map((d:any) => {
          d.activo=false;
          d.disabled=false;
          d.visible=false;
          switch(d.id){
            case 1: 
                d.articulo='';
                d.commentary=''; 
                d.files=null;  
                d.cycle=null;  
              break;
            case 2: 
                d.articulo='(Art. 9)'; 
                d.commentary=null; 
                d.files=null;  
                d.cycle={ id: 0, name: '', state_cycle: null, pt_md: null };  
              break;
            case 3: 
                d.articulo='(Art. 19)'; 
                d.commentary=null; 
                d.files=[];  
                d.cycle={ id: 0, name: '', state_cycle: null, pt_md: null };  
              break;
          }
      });
      //console.log (':::catDecisionesStore: ', get().catDecisionesStore );
      return(get().catDecisionesStore);
    },
  
  catPrincipiosStore: [], ///response.data de la tarea: GetAllQuality +  elementos de uso en el front

    //*Tareas: GetAllQuality //*RP
    guardaGetAllQualityStore: async (responseAPI:any) => { 
      //console.log('guardaGetAllDecisionStore - responseAPI:', responseAPI)
      set ( { catPrincipiosStore: responseAPI } )

      get().catPrincipiosStore.map((p:any) => {
          p.activo=false;
          p.disabled=false;
          p.visible=false;
          p.hitId=0;
          p.hitName="";
          p.hit= { "id": 0, "name": ""};
          p.hitOpciones= [
            { "id": 1,  "name": "Incrementa", "activo":false},
            { "id": -1, "name": "Decrementa", "activo":false}];
          //{ "id": 0,  "name": "Sin especificar", "activo":false, "visible":false} // ojo ya viene con sent=true y nos da directamente la información, no se selecciona
      });
      //console.log (':::catPrincipiosStore: ', get().catPrincipiosStore );
      return(get().catPrincipiosStore);
    },

  catCiclosStore: [], ///response.data de la tarea: GetAllQuality +  elementos de uso en el front

    //*Tareas: GetAllCycles  //*RP // recibe el response.data y lo guarda en variable store: catPruebasStore
    guardaGetAllCyclesStore: async (responseAPI:any) => { 
      //console.log('guardaGetAllDecisionStore - responseAPI:', responseAPI)
      set ( { catCiclosStore: responseAPI } )
      let met = "";
        get().catCiclosStore.map((p:any) => {
          p.activo=false;
          p.disabled=false;
          p.visible=false;
        })
      //console.log (':::catCiclosStore: ', get().catCiclosStore );
      return(get().catCiclosStore);
    },

  catPruebasStore: [], ///response.data de la tarea: GetAllProof +  elementos de uso en el front  

    //*Tareas: GetAllProof   //*RD
    guardaGetAllProofStore: async (responseAPI:any) => { 
      //console.log('guardaGetAllProofStore - responseAPI:', responseAPI)
      set ( { catPruebasStore: responseAPI } )
      get().catPruebasStore.map((p:any) => {
          p.activo=false;
          p.nombreCorto= (p.name.length > 42) ? p.name.substring(0,42) + '...' : p.name; 
          p.descripcion = '';
          //p.otraTexto = '';
      });
      //console.log (':::catPruebasStore: ', get().catPruebasStore );
      return(get().catPruebasStore);
    },
  
}));

export default catalogsStore;
